import React from 'react';

interface CloudProviderLogosProps {
  className?: string;
}

export const CloudProviderLogos: React.FC<CloudProviderLogosProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center -space-x-1.5 ml-[-4px] ${className}`}>
      <div className="w-5 h-5 rounded-full bg-white/70 backdrop-blur-sm flex items-center justify-center shadow-[3px_1px_8px_rgba(0,0,0,0.12)] relative z-30">
        <img src="/google.svg" alt="Google" className="w-3.5 h-3.5 opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
      </div>
      <div className="w-5 h-5 rounded-full bg-white/70 backdrop-blur-sm flex items-center justify-center shadow-[3px_1px_8px_rgba(0,0,0,0.12)] relative z-20">
        <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 opacity-60 group-hover:opacity-80 transition-opacity duration-300">
          <path fill="currentColor" d="M17.05 20.28c-.98.95-2.05.88-3.08.41-1.09-.47-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.41C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08M12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.32 2.32-1.66 4.23-3.74 4.25"/>
        </svg>
      </div>
      <div className="w-5 h-5 rounded-full bg-white/70 backdrop-blur-sm flex items-center justify-center shadow-[3px_1px_8px_rgba(0,0,0,0.12)] relative z-10">
        <img src="/microsoft.svg" alt="Microsoft" className="w-3.5 h-3.5 opacity-60 group-hover:opacity-80 transition-opacity duration-300" />
      </div>
    </div>
  );
}; 